import {
  CreateWorkspaceResponseSchema,
  type CreateWorkspaceBody,
  type CreateWorkspaceResponse,
} from '../../src/shared/tenants';
import { apiPost } from './client';

/**
 * Typed client for workspace onboarding (ARCHITECTURE_PLAN §9):
 *   POST /api/tenants — create a workspace; the creator becomes its owner.
 *
 * The body is the shared `CreateWorkspaceBody` (name, slug, vertical, timezone);
 * the response is validated against the shared `CreateWorkspaceResponseSchema`.
 */
export function createWorkspace(body: CreateWorkspaceBody): Promise<CreateWorkspaceResponse> {
  return apiPost('/api/tenants', body, CreateWorkspaceResponseSchema);
}
